"use strict";

require("core-js/modules/es.array.reduce");

exports.__esModule = !0, exports["default"] = exports.mapToTheme = exports._dotProp = exports._convertToObject = void 0;

var _convertToObject = function _convertToObject(a) {
  for (var b = arguments.length, c = Array(1 < b ? b - 1 : 0), d = 1; d < b; d++) {
    c[d - 1] = arguments[d];
  }

  return function (b) {
    var d = a.reduce(function (a, d, e) {
      var f = c[e] || "";
      return "function" == typeof f && (f = f(b)), a + d + f;
    }, ""),
        e = d.split(";").map(function (a) {
      return a.trim();
    }).filter(function (a) {
      return !!a;
    });
    return e.reduce(function (a, b) {
      var c,
          d = b.split(":").map(function (a) {
        return a.trim();
      }),
          e = d[0],
          f = d[1];
      return Object.assign(a, (c = {}, c[e] = f, c));
    }, {});
  };
};

exports._convertToObject = _convertToObject;

var styledMap = function styledMap() {
  for (var a = arguments.length, b = Array(a), c = 0; c < a; c++) {
    b[c] = arguments[c];
  }

  return function (a) {
    var c = Array.isArray(b[0]) ? _convertToObject.apply(void 0, b)(a) : b[b.length - 1];
    var d = Object.keys(c);

    if ("string" == typeof b[0]) {
      var e = a[b[0]];
      if (c[e]) return c[e];
    } else {
      var f = d.filter(function (b) {
        return a[b];
      });
      if (f.length) return c[f.pop()];
    }

    return Object.prototype.hasOwnProperty.call(c, "default") ? c["default"] : c[d.pop()];
  };
},
    _dotProp = function _dotProp(a, b) {
  return a.split(".").reduce(function (a, b) {
    return a[b];
  }, b);
};

exports._dotProp = _dotProp;

var mapToTheme = function mapToTheme(a, b) {
  return function (c) {
    return b ? styledMap(b, _dotProp(a, c.theme)) : styledMap(_dotProp(a, c.theme));
  };
};

exports.mapToTheme = mapToTheme;
var _default = styledMap;
exports["default"] = _default;